__turbopack_context__.v({
  "accordion__body": "AccordionGeneric-module-scss-module__rufV6W__accordion__body",
  "accordion__button": "AccordionGeneric-module-scss-module__rufV6W__accordion__button",
  "accordion__header": "AccordionGeneric-module-scss-module__rufV6W__accordion__header",
});
